export default "__VITE_ASSET__CVdxvQEA__"